import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Layout from "../components/layout/Layout";
import ProductCard from "../components/ProductCard";
import api from "../lib/api";
import useSeo from "../hooks/useSeo";
import { ChevronRight, ArrowUpRight } from "lucide-react";

export default function CategoryDetail() {
  const { slug } = useParams();
  const [cat, setCat] = useState(null);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api.get(`/categories/${slug}`).then((r) => setCat(r.data)).catch(() => {});
    api.get("/products", { params: { category: slug, limit: 50 } })
      .then((r) => setProducts(r.data.items || []));
  }, [slug]);

  useSeo({
    title: cat ? `${cat.name} — Otel Pro` : "Kategori — Otel Pro",
    description: cat?.description,
  });

  if (!cat) {
    return <Layout><div className="section-pad container-site">Yükleniyor...</div></Layout>;
  }

  return (
    <Layout>
      <div className="bg-softbg">
        <div className="container-site py-5 flex items-center gap-2 text-xs text-gray-500">
          <Link to="/" className="hover:text-navy">Ana Sayfa</Link>
          <ChevronRight size={12} />
          <Link to="/kategoriler" className="hover:text-navy">Kategoriler</Link>
          <ChevronRight size={12} />
          <span className="text-navy font-medium">{cat.name}</span>
        </div>
      </div>

      <section
        className="relative bg-navy text-white py-20"
        style={cat.image ? { backgroundImage: `linear-gradient(rgba(8,17,29,0.85), rgba(8,17,29,0.7)), url(${cat.image})`, backgroundSize: "cover", backgroundPosition: "center" } : {}}
        data-testid="category-hero"
      >
        <div className="container-site">
          <p className="accent-script text-gold text-xl mb-1">Kategori</p>
          <h1 className="heading-serif text-3xl md:text-5xl font-semibold">{cat.name}</h1>
          <p className="text-white/75 max-w-2xl mt-3 text-base leading-relaxed">{cat.description}</p>
        </div>
      </section>

      <section className="section-pad">
        <div className="container-site">
          <div className="flex items-center justify-between mb-8">
            <h2 className="heading-serif text-2xl font-semibold text-navy">Ürünler ({products.length})</h2>
            <Link to="/iletisim" className="btn-outline-gold text-sm !py-2 !px-4" data-testid="cat-detail-bulk-quote">
              Bu Kategoriyi Toplu Teklif Al <ArrowUpRight size={14} />
            </Link>
          </div>
          {products.length === 0 ? (
            <p className="text-center text-gray-500 py-12">Bu kategoride henüz ürün yok.</p>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {products.map((p) => <ProductCard key={p.id} product={p} />)}
            </div>
          )}
        </div>
      </section>
    </Layout>
  );
}
